type PropTypes = {
  className?: string
}

const CrossIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="18"
        height="18"
        fill="white"
        fillOpacity="0.01"
      />
      <path d="M13.5 5.2875L12.7125 4.5L9 8.2125L5.2875 4.5L4.5 5.2875L8.2125 9L4.5 12.7125L5.2875 13.5L9 9.7875L12.7125 13.5L13.5 12.7125L9.7875 9L13.5 5.2875Z" fill="#161616" />
    </svg>

  )
}

export default CrossIcon
